import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'party-agreement-search-dialog',
    templateUrl: './party-agreement-search-dialog.component.html',
    providers: [DataService] //force as a local provider
})
export class PartyAgreementSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        this.parentActiveModal = this.activeModal;

        this.model.criteria.BookEntityID = 'CURRENTBOOK';

        switch (this.model.criteria.Role_Type) {
            case 'BK':
                this.model.title = 'Select Broker / Agreement';
                this.objectType = 'BrokerAgreementTerm';
                break;

            case 'SP':
                this.model.title = 'Select Source Supplier / Agreement';
                this.objectType = 'SupplierAgreementTerm';
                break;

            default:
                this.model.title = 'Select Agreement';
        }

        this.model.criteria.View = 'Standard';
        this.model.criteria.Entity_Name_Mode = 'CONTAINSALLWORDS';

        return true;
    }
}
